<template>
  <Row>
    <Col span="24"
      ><p class="kanbanDes">
        <label>在线车辆</label><span>{{ onLine }}台</span><label>总车辆</label
        ><span>{{ total }}台</span>
      </p></Col
    >
    <div
      id="wavewrap"
    >
      <qiuqiu
        :percent="percent"
        :size="120"
        :trail-width="10"
        trail-color="#163358"
        :stroke-width="10"
        stroke-color="#3ebaf7"
      >
        <p style="font-size: 24px; margin-top: 36px; color: #fff">
          {{ percent }}
        </p>
        <p style="color: #fff">在线率/%</p>
      </qiuqiu>
    </div>
    <Col span="24">
      <Row style="text-align: center">
        <Col span="8"
          ><h2 class="ewlcrrw">{{ driving }}</h2>
          <p>行驶数量</p></Col
        >
        <Col span="8">
          <h2 class="ewlcrrw">{{ stay }}</h2>
          <p>停留数量</p>
        </Col>
        <Col span="8">
          <h2 class="ewlcrrw">{{ parking }}</h2>
          <p>停车数量</p>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import qiuqiu from "./qiuqiu.vue";
export default {
  components:{qiuqiu},
  data() {
    return {
      onLine: 0,
      parking: 0,
      total: 0,
      item: {},
      offline: 0,
      unactivated: 0,
      stay: 0,
      percent:0,
      driving:0
    };
  },
  methods: {
    zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },

    getData() {

      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/countCarStatus",
        data: this.item,
      }).then((res) => {
        var data = res.data.data;
        this.onLine = data.online;
        this.parking = data.parking;
        this.driving = data.driving;
        this.total = data.total;
        this.offline = data.offline;
        this.stay = data.stay;
        this.percent = data.onlineRate;
        this.unactivated = data.unactivated;
        
      });
    },
     zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
h2.ewlcrrw {
  font-size: 20px;
  font-weight: bold;
}
#wavewrap{
  width: 120px;
  height: 120px;
  margin: 20px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/feiyong/saodiche.vue